// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1jPMk","errorLogs":"styles_errorLogs__2bMN6"};